export const SliderData = [
  {
    src: '/info/1.webp'
  },
  {
    src: '/info/2.webp'
  },
  {
    src: '/info/3.webp'
  },
  {
    src: '/info/4.webp'
  },
  {
    src: '/info/5.webp'
  }
];
